/* AQUON Feature Cards - mobile swipe carousel dots.
   Desktop shows a 3-up grid (dots hidden by CSS); on mobile the cards become a
   horizontal snap carousel and these dots track / control the active card. */
(function () {
  'use strict';

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initCarousel(section) {
    if (section.__afcInit) return;
    section.__afcInit = true;

    var track = section.querySelector('[data-afc-track]');
    var dots = qsa('[data-afc-dot]', section);
    var cards = qsa('.afc__card', section);
    if (!track || dots.length < 2 || !cards.length) return;

    function setActive(i) {
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    // Tap a dot -> centre that card
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    // Track the centred card and light its dot
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            var i = cards.indexOf(e.target);
            if (i >= 0) setActive(i);
          }
        });
      }, { root: track, threshold: [0.6] });
      cards.forEach(function (c) { io.observe(c); });
    }
  }

  function boot() {
    qsa('[data-afc]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
